var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "layout__controls" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c(
            "button",
            {
              staticClass: "btn-info",
              attrs: { type: "button" },
              on: { click: _vm.consultar }
            },
            [
              _c("i", { staticClass: "fa fa-search" }),
              _c("span", [_vm._v("Consultar")])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-success",
              attrs: { type: "button" },
              on: { click: _vm.exportarExcel }
            },
            [
              _c("i", { staticClass: "fa fa-file-excel-o" }),
              _c("span", [_vm._v("Exportar")])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card mb-2" }, [
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c("div", { staticClass: "form-inline" }, [
              _c("div", { staticClass: "form-inline__title" }, [
                _vm._v("\n              Fecha\n            ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-inline__content" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipoFecha,
                        expression: "form.tipoFecha"
                      }
                    ],
                    attrs: { type: "radio", value: "H" },
                    domProps: { checked: _vm._q(_vm.form.tipoFecha, "H") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipoFecha", "H")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Hoy")])
                ]),
                _vm._v(" "),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipoFecha,
                        expression: "form.tipoFecha"
                      }
                    ],
                    attrs: { type: "radio", value: "A" },
                    domProps: { checked: _vm._q(_vm.form.tipoFecha, "A") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipoFecha", "A")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Ayer")])
                ]),
                _vm._v(" "),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipoFecha,
                        expression: "form.tipoFecha"
                      }
                    ],
                    attrs: { type: "radio", value: "P" },
                    domProps: { checked: _vm._q(_vm.form.tipoFecha, "P") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipoFecha", "P")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Personalizado")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.tipoFecha == "P",
                        expression: "form.tipoFecha == 'P'"
                      }
                    ],
                    staticClass: "form-field"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "datepicker-field datepicker-field--stretch"
                      },
                      [
                        _c("VueCtkDateTimePicker", {
                          attrs: {
                            id: "desde",
                            locale: "es",
                            "only-date": "",
                            "no-label": "",
                            noClearButton: "",
                            "button-now-translation": "Ahora",
                            format: "YYYY-MM-DD",
                            formatted: "YYYY-MM-DD",
                            label: "Seleccione fecha..."
                          },
                          model: {
                            value: _vm.form.fechaDesde,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fechaDesde", $$v)
                            },
                            expression: "form.fechaDesde"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [_vm._v("Desde:")])
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.tipoFecha == "P",
                        expression: "form.tipoFecha == 'P'"
                      }
                    ],
                    staticClass: "form-field"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "datepicker-field datepicker-field--stretch"
                      },
                      [
                        _c("VueCtkDateTimePicker", {
                          attrs: {
                            id: "hasta",
                            locale: "es",
                            "only-date": "",
                            "no-label": "",
                            noClearButton: "",
                            "button-now-translation": "Ahora",
                            format: "YYYY-MM-DD",
                            formatted: "YYYY-MM-DD",
                            label: "Seleccione fecha..."
                          },
                          model: {
                            value: _vm.form.fechaHasta,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fechaHasta", $$v)
                            },
                            expression: "form.fechaHasta"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [_vm._v("Hasta:")])
                      ],
                      1
                    )
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c("div", { staticClass: "form-inline" }, [
              _c("div", { staticClass: "form-inline__title" }, [
                _vm._v("Estado del préstamo")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-inline__content" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.estado_prestamo,
                        expression: "form.estado_prestamo"
                      }
                    ],
                    attrs: { type: "radio", value: "A" },
                    domProps: {
                      checked: _vm._q(_vm.form.estado_prestamo, "A")
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "estado_prestamo", "A")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Pendientes")])
                ]),
                _vm._v(" "),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.estado_prestamo,
                        expression: "form.estado_prestamo"
                      }
                    ],
                    attrs: { type: "radio", value: "I" },
                    domProps: {
                      checked: _vm._q(_vm.form.estado_prestamo, "I")
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "estado_prestamo", "I")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Inactivos")])
                ]),
                _vm._v(" "),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.estado_prestamo,
                        expression: "form.estado_prestamo"
                      }
                    ],
                    attrs: { type: "radio", value: "P" },
                    domProps: {
                      checked: _vm._q(_vm.form.estado_prestamo, "P")
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "estado_prestamo", "P")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Pagados")])
                ]),
                _vm._v(" "),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.estado_prestamo,
                        expression: "form.estado_prestamo"
                      }
                    ],
                    attrs: { type: "radio", value: "T" },
                    domProps: {
                      checked: _vm._q(_vm.form.estado_prestamo, "T")
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "estado_prestamo", "T")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Todos")])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c("div", { staticClass: "form-field" }, [
              _c(
                "div",
                { staticClass: "multiselect-field" },
                [
                  _c("multiselect", {
                    attrs: {
                      "preserve-search": "",
                      placeholder: "Busque y seleccione...",
                      selectedLabel: "Seleccionado",
                      selectLabel: "Presiona enter para seleccionar",
                      deselectLabel: "Presiona enter para eliminar",
                      label: "descripcion",
                      "track-by": "descripcion",
                      multiple: "",
                      options: _vm.rutas
                    },
                    on: {
                      "search-change": _vm.onSearchRutas,
                      input: _vm.inputRutas
                    },
                    model: {
                      value: _vm.selectedRutas,
                      callback: function($$v) {
                        _vm.selectedRutas = $$v
                      },
                      expression: "selectedRutas"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "rutas" } }, [_vm._v("Rutas")])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      id: "buscar",
                      placeholder: "Realice una consulta..."
                    },
                    model: {
                      value: _vm.form.searchP,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "searchP", $$v)
                      },
                      expression: "form.searchP"
                    }
                  },
                  [_vm._v("\n              Consultar\n            ")]
                )
              ],
              1
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-xs-12" },
        [
          _c("k-table", {
            ref: "listaClientes",
            attrs: {
              createButton: false,
              deleteButton: false,
              editButton: false,
              path: _vm.path,
              params: _vm.form,
              buscarButton: false,
              columns: _vm.columns
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Clientes")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44474b7b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44474b7b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/clientes/ListaClientesRuta.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-44474b7b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/clientes/ListaClientesRuta.vue
// module chunks = 0